// CustomImage.js
import React from 'react';

import imgUrl from './urlImg';


const CustomImage = ({ src, alt, className, loading }) => {
  // Replace "public" with "storage" in the src URL and prepend apiUrl
  const modifiedSrc = src ? `${imgUrl}/${src.replace('public', 'storage')}` : '';

  return <img src={modifiedSrc} alt={alt} className={className} loading={loading || 'lazy'} />;
};

export default CustomImage;
